import { Component, OnInit, ViewChild } from '@angular/core'
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { ContactService } from 'app/_services/contact.service'
import { GoogleAnalyticsService } from 'app/_services/google-analytics.service'
import { environment } from 'environments/environment'
import { RecaptchaModule } from 'ng-recaptcha'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { InputValidationDirective } from '../../shared/directives/input-validation.directive'
import { FormCustomerComponent } from '../../shared/form-customer/form-customer.component'
import { NgIf } from '@angular/common'
import { firstValueFrom } from 'rxjs'

@Component({
    selector: 'form-contact',
    templateUrl: './form-contact.component.html',
    standalone: true,
    imports: [NgIf, FormsModule, ReactiveFormsModule, FormCustomerComponent, InputValidationDirective, FontAwesomeModule, RecaptchaModule],
})
export class FormContactComponent implements OnInit {
    @ViewChild('captchaRef', { static: true }) captchaRef
    captchaActive = environment.captcha.active

    company
    language
    customer

    admin
    wasValidated = false

    form
    redirect
    serverError = false

    // Submit
    loading = {
        submit: false,
    }

    contact

    constructor(
        private fb: UntypedFormBuilder,
        private activatedRoute: ActivatedRoute,
        private contactService: ContactService,
        private googleAnalyticsService: GoogleAnalyticsService
    ) {}

    ngOnInit() {
        this.googleAnalyticsService.init('contact')
        this.initData()
    }

    initData() {
        const params = this.activatedRoute.snapshot.params
        const queryParams = this.activatedRoute.snapshot.queryParams

        this.contactService.read(params, queryParams, 'ticket').subscribe((res) => {
            const data = res.data

            this.admin = data.admin
            this.contact = data.contact
            this.language = data.language
            this.company = data.company
            this.redirect = {
                en: `//www.${this.company.domain}/en/contact-sent/`,
                nl: `//www.${this.company.domain}/contact-verstuurd/`,
            }
            // Start form
            this.initForms()
        })
    }

    initForms() {
        this.form = this.fb.group({
            captcha: this.fb.group({
                success: false,
                value: null,
            }),
            comment: ['', Validators.required],
            customer: {
                language: this.language.id,
            },
        })
    }

    submitClick() {
        const canSubmit = this.submitCheckFor()
        if (!canSubmit) return (this.wasValidated = true)

        const captchaSuccess = !!this.form.get('captcha.success').value
        const captchaInactive = !this.captchaActive
        if (captchaSuccess) return this.submit('')
        if (captchaInactive) return this.submit('')
        this.captchaRef.execute()
    }

    submitCheckFor() {
        if (this.loading.submit) return false

        const validComment = this.form.get('comment').valid
        if (!validComment) return false

        const validCustomer = this.form.get('customer').valid
        if (!validCustomer) return false

        return true
    }

    async submit(captchaResp) {
        this.loading.submit = true
        this.serverError = false

        const contact = {
            ...this.contact,
            ...this.form.value,
        }

        // Log press submit
        await this.googleAnalyticsService.submit('contact', contact, this.language.id)

        // Patch value
        if (captchaResp) this.form.get('captcha.value').patchValue(captchaResp)

        // Validate the captcha
        const res = await firstValueFrom(this.contactService.validateCaptcha(contact))

        // Patch Captcha
        this.contact = res.data.contact
        this.form.get('captcha').patchValue(this.contact.captcha)

        try {
            await firstValueFrom(this.contactService.submit(this.contact._id, this.form.value))
            this.doRedirect()
        } catch (ex) {
            if (ex.error.error) this.serverError = true
            this.loading.submit = false
        }
    }

    doRedirect() {
        window.top.location.href = this.redirect[this.language.id]
    }
}
